import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/prospects/$prospectId/")({
  component: RouteComponent
});

function RouteComponent() {
  const params = Route.useParams();
  return (
    <Navigate to={`${Route.fullPath}recordings`} params={params} replace />
  );
}
